<template>
  <footer class="app-footer">
    <span>&copy; 2018 - {{year}} GrandShipper.</span>
    <span class="ml-auto">All Rights Reserved.</span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer',

  computed: {
    year() {
      return moment().format('YYYY');
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Footer.vue